import { CWILL_EVENT_NAMES } from "@channelwill/report"
import { Badge, Text } from "@shopify/polaris"
import classNames from "classnames"
import React from "react"

import { BadgeType } from "@/api/common/types/RecommendApps"
import MonorailTracker from "@/utils/monorailTracker"

import styles from "./index.module.scss"

interface APPCardProps {
  id?: number
  logo: string
  title: string
  description: string
  link: string
  hasHover?: boolean
  padding?: "300" | "400"
  badges: BadgeType[] | null;
  position?: string;
}

const APPCard: React.FC<APPCardProps> = ({
  id,
  logo,
  title,
  link,
  description,
  hasHover,
  padding = "300",
  badges = [],
  position = "home_recommended_apps",
}) => {
  return (
    <a
      onClick={() => {
        if (id){
          MonorailTracker.trackRecommendAppClicked(id)
          window.cwreport && window.cwreport.report(CWILL_EVENT_NAMES.RECOMMEND_APP_CLICK, {
            position: position,
            recommend_app_id: id ? String(id) : "",
            recommend_app_name: title,
          })
        }
      }}
      target={"_blank"}
      href={link}
      className={classNames(styles.cardWrapper, hasHover ? styles.hasHover : styles.defaultHover)}
      rel="noreferrer"
      style={{ padding: `var(--p-space-${padding})` }}
    >
      {/* <Card padding={padding}>*/}
      <div className="flex items-start gap-2">
        {/* Logo */}
        <div className={styles.logo}>
          <img
            src={logo}
            alt={title}
          />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {/* Title and Badge */}
          <div className="flex flex-col gap-1">
            <Text variant="bodyMd" fontWeight={"medium"} as="h4" tone={"base"}>
              <div className={"ellipsis"}>{title}</div>
            </Text>
            {badges && badges.length > 0 && (
              <div className={"flex gap-1 flex-wrap h-[20.5px] overflow-hidden"}>
                {badges.map((badge) => (
                  <div key={badge.content}><Badge tone={badge.tone}>
                    {badge.content}
                  </Badge></div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Description */}
      {description && (
        <div className="mt-2 line-clamp-2">
          <Text variant="bodyMd" as="p" tone="subdued">
            {description}
          </Text>
        </div>
      )}
      {/* </Card>*/}
    </a>
  )
}

export default APPCard
